/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Gauge(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M215.07227,144.95117a8.00019,8.00019,0,0,1-4.14161-15.45508l22.95557-6.15088A112.20282,112.20282,0,0,0,136,48.28271V72a8,8,0,0,1-16,0V48.29443c-45.14648,3.23975-83.01074,33.69385-97.582,75.13233l22.65137,6.06933a8.0002,8.0002,0,1,1-4.14161,15.45508L18.18945,138.8584A114.064,114.064,0,0,0,16,161.12891V184a16.01833,16.01833,0,0,0,16,16H87.22314L165.48389,98.00879a8.00009,8.00009,0,0,1,12.69384,9.74023L107.39062,200H224a16.01833,16.01833,0,0,0,16-16V160a113.2326,113.2326,0,0,0-1.99658-21.19336Z" />
    </Svg>
  );
}

export default Gauge;
